import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid page top" }
const _hoisted_2 = { class: "row row2 col-md-12" }
const _hoisted_3 = { class: "car-info-row" }
const _hoisted_4 = {
  key: 0,
  class: "car-info-data-age"
}
const _hoisted_5 = { class: "ib" }

import TopLeftPane from 'src/components/Top/TopLeftPane.vue';
import MapElemInfoNone from 'src/components/Top/mapElemInfoComponents/MapElemInfoNone.vue';
import MapElemInfoNew from 'src/components/Top/mapElemInfoComponents/MapElemInfoNew.vue';
import MapElemInfoCar from 'src/components/Top/mapElemInfoComponents/MapElemInfoCar.vue';
import MapElemInfoMovie from 'src/components/Top/mapElemInfoComponents/MapElemInfoMovie.vue';
import MapElemInfoComment from 'src/components/Top/mapElemInfoComponents/MapElemInfoComment.vue';
import MapElemInfoCommentContainer from 'src/components/Top/mapElemInfoComponents/MapElemInfoCommentContainer.vue';
import MapElemInfoLandApEmergency from 'src/components/Top/mapElemInfoComponents/MapElemInfoLandApEmergency.vue';
import MapElemInfoJunkaiTenkenReportTenkenData
  from 'src/components/Top/mapElemInfoComponents/MapElemInfoJunkaiTenkenReportTenkenData.vue';
import MapElemInfoLandAiDetections from 'src/components/Top/mapElemInfoComponents/MapElemInfoLandAiDetections.vue';
import TopDebugComponent from 'src/components/Top/TopDebugComponent/index.vue';
import MovieSearchResultPane from 'src/components/Top/MovieSearchResultPane.vue';
import MovieSearchBar from 'src/components/Top/MovieSearchBar.vue';
import DeleteConfirmModal from 'src/components/Top/DeleteConfirmModal.vue';
import MovieTagSearchModal from 'src/components/Top/MovieTagSearchModal.vue';
import MovieTagEditModal from 'src/components/Top/MovieTagEditModal.vue';
import ExtremeMap from 'src/components/lib/ExtremeMap/index.vue';
import MoviePlayer from 'src/components/lib/MoviePlayer/index.vue';
import MoviePlayerCompareMode from 'src/components/lib/MoviePlayerCompareMode/index.vue';
import { provideTopView } from 'src/composables/useTopView';

// Top.vue は provider 本体。全ドメインストアを生成・provide し、戻り値で受け取る。
// （provide/inject は親→子のため、provider 自身は inject できず戻り値経由で使う。
//  子コンポーネントは useXxxStore() で inject する。）

export default /*@__PURE__*/_defineComponent({
  ...{
  components: {
    MapElemInfoNone,
    MapElemInfoNew,
    MapElemInfoCar,
    MapElemInfoMovie,
    MapElemInfoComment,
    MapElemInfoCommentContainer,
    MapElemInfoLandApEmergency,
    MapElemInfoJunkaiTenkenReportTenkenData,
    MapElemInfoLandAiDetections,
  },
},
  __name: 'Top',
  setup(__props) {

const {
  shell,
  mapSelection,
  movieSearch,
  imageModal,
  geoItemLayers,
  movieTagEdit,
  moviePlayer,
} = provideTopView();

// 画面共有状態（レイアウト・refs・マスタ・車両）
const {
  state,
  geoItemsMeta,
  movieLayerMeta,
  styles,
  refExtremeMap,
  refGeneralSearchBarRow,
  refPaneLeft,
  refPaneCenter,
  refMapTopMiscBar,
  refMapTopMiscBarLeft,
  refMapTopMiscBarRight,
  refMapSelectedElemInfoArea,
  refPaneRight,
  dtFormat,
  hasRoleSuperAdmin,
  isMapReady,
  paneResizeStopped,
  carState,
} = shell;

// 地図選択
const {
  mapElem,
  currentElemInfoComponent,
  onClickMap,
  onMapItemClicked,
  onMapAllDeselected,
  createMapSelectedElem,
  updateMapSelectedElem,
  confirmDeleteMapSelectedElem,
  playMapSelectedElem,
  onMapSelectedElemAreaSizeChange,
  showPreviousGeoItem,
  showNextGeoItem,
  getGeoItemById,
} = mapSelection;

// 動画検索
const {
  movieSearch: movieSearchState,
  doAreaMovieSearch,
} = movieSearch;

// 画像モーダル
const { imageViewModal, showImage, closeImageModal } = imageModal;

// 動画プレイヤー
const {
  moviePlayerState,
  refMoviePlayer,
  refMoviePlayerCompareMode,
  showMoviePlayerFullMode,
  showMoviePlayerCompareMode,
  closeMoviePlayer,
  switchMoviePlayerToCompareMode,
  switchMoviePlayerToFullMode,
} = moviePlayer;

// ジオアイテムレイヤー
const {
  visibleGeoItemLayers,
  onMapZoomChanged,
} = geoItemLayers;

// 動画タグ編集
const { startEditMovieTag } = movieTagEdit;

// <component :is="..."> の文字列解決に必要なコンポーネントのみ登録する
// （import してタグ名で使用するコンポーネントは script setup が自動解決する）


return (_ctx: any,_cache: any) => {
  const _component_MultipaneResizer = _resolveComponent("MultipaneResizer")!
  const _component_Multipane = _resolveComponent("Multipane")!
  const _component_LoadWaitSpinner = _resolveComponent("LoadWaitSpinner")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalImageView = _resolveComponent("ModalImageView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row row1 col-md-12",
      ref_key: "refGeneralSearchBarRow",
      ref: refGeneralSearchBarRow
    }, [
      _createVNode(MovieSearchBar, {
        devices: _unref(carState).devices
      }, null, 8, ["devices"])
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Multipane, {
        class: "vertical-panes",
        onPaneResizeStop: _unref(paneResizeStopped)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "pane-left",
            style: _normalizeStyle({
            'min-width': _unref(styles).paneStyles.sideMinWidth,
            'max-width': _unref(styles).paneStyles.sideMaxWidth,
          }),
            ref_key: "refPaneLeft",
            ref: refPaneLeft
          }, [
            _createVNode(TopLeftPane)
          ], 4),
          _createVNode(_component_MultipaneResizer),
          _createElementVNode("div", {
            class: "pane-center",
            style: _normalizeStyle({
            'min-width': _unref(styles).paneStyles.centerMinWidth,
            'max-width': _unref(styles).paneStyles.centerMaxWidth,
          }),
            ref_key: "refPaneCenter",
            ref: refPaneCenter
          }, [
            _createElementVNode("div", {
              class: "misc-info",
              ref_key: "refMapTopMiscBar",
              ref: refMapTopMiscBar
            }, [
              _createElementVNode("div", {
                class: "misc-info-left",
                ref_key: "refMapTopMiscBarLeft",
                ref: refMapTopMiscBarLeft
              }, null, 512),
              _createElementVNode("div", {
                class: "misc-info-right ta-right",
                ref_key: "refMapTopMiscBarRight",
                ref: refMapTopMiscBarRight
              }, [
                _createElementVNode("div", _hoisted_3, [
                  (!!_unref(carState).carsUpdatedAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, " 車両データ取得時刻: " + _toDisplayString(_unref(dtFormat)(_unref(carState).carsUpdatedAt, 'yyyy/mm/dd HH:MM:SS')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "spacer-row" }, null, -1))
              ], 512)
            ], 512),
            _withDirectives(_createVNode(ExtremeMap, {
              ref_key: "refExtremeMap",
              ref: refExtremeMap,
              "map-essentials": _unref(state).extremeMapEssentials,
              "disable-movie-layer-interaction": false,
              "should-fit-initial-extent": _unref(state).shouldFitInitialExtent,
              onClickMap: _unref(onClickMap),
              onClickItem: _unref(onMapItemClicked),
              onAllDeselected: _unref(onMapAllDeselected),
              onZoomChanged: _unref(onMapZoomChanged)
            }, null, 8, ["map-essentials", "should-fit-initial-extent", "onClickMap", "onClickItem", "onAllDeselected", "onZoomChanged"]), [
              [_vShow, _unref(isMapReady)]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["map-selected-elem-info-area mt4", { hide: !_unref(mapElem).mapSelectedElemInfo }]),
              ref_key: "refMapSelectedElemInfoArea",
              ref: refMapSelectedElemInfoArea
            }, [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentElemInfoComponent)), {
                  elem: _unref(mapElem).mapSelectedElemInfo,
                  "visible-layers": _unref(visibleGeoItemLayers),
                  "update-failed": _unref(mapElem).mapSelectedElemUpdateFailed,
                  "create-failed": _unref(mapElem).mapSelectedElemCreateFailed,
                  "fetch-geo-item-failed": _unref(mapElem).getGeoItemByIdFailed,
                  onCreate: _unref(createMapSelectedElem),
                  onUpdate: _unref(updateMapSelectedElem),
                  onConfirmDelete: _unref(confirmDeleteMapSelectedElem),
                  onShowImage: _unref(showImage),
                  onAreaMovieSearch: _unref(doAreaMovieSearch),
                  onPlayMovie: _unref(playMapSelectedElem),
                  onEditMovieTag: _unref(startEditMovieTag),
                  onComponentResized: _unref(onMapSelectedElemAreaSizeChange),
                  onShowPreviousGeoItem: _unref(showPreviousGeoItem),
                  onShowNextGeoItem: _unref(showNextGeoItem),
                  onFetchGeoItem: _unref(getGeoItemById)
                }, null, 40, ["elem", "visible-layers", "update-failed", "create-failed", "fetch-geo-item-failed", "onCreate", "onUpdate", "onConfirmDelete", "onShowImage", "onAreaMovieSearch", "onPlayMovie", "onEditMovieTag", "onComponentResized", "onShowPreviousGeoItem", "onShowNextGeoItem", "onFetchGeoItem"]))
              ], 1024))
            ], 2),
            (_unref(hasRoleSuperAdmin) && _unref(isMapReady))
              ? (_openBlock(), _createBlock(TopDebugComponent, {
                  key: 0,
                  "ref-extreme-map": _unref(refExtremeMap)!,
                  cars: _unref(carState).cars,
                  style: {"margin":"24px 16px"}
                }, null, 8, ["ref-extreme-map", "cars"]))
              : _createCommentVNode("", true)
          ], 4),
          _createVNode(_component_MultipaneResizer),
          _createElementVNode("div", {
            class: "pane-right",
            ref_key: "refPaneRight",
            ref: refPaneRight,
            style: _normalizeStyle({
            'min-width': _unref(styles).paneStyles.sideMinWidth,
            'max-width': _unref(styles).paneStyles.sideMaxWidth,
          })
          }, [
            _createVNode(MovieSearchResultPane)
          ], 4)
        ]),
        _: 1
      }, 8, ["onPaneResizeStop"])
    ]),
    _withDirectives(_createVNode(MoviePlayer, {
      ref_key: "refMoviePlayer",
      ref: refMoviePlayer,
      "movie-lists": _unref(moviePlayerState).moviePlayerMovieLists,
      "movie-list-id": _unref(moviePlayerState).moviePlayerFullMovieListId,
      "extreme-map-essentials": _unref(state).extremeMapEssentials,
      "parent-geo-items-meta": _unref(geoItemsMeta),
      onClose: _unref(closeMoviePlayer),
      onSwitchToCompareMode: _unref(switchMoviePlayerToCompareMode)
    }, null, 8, ["movie-lists", "movie-list-id", "extreme-map-essentials", "parent-geo-items-meta", "onClose", "onSwitchToCompareMode"]), [
      [_vShow, _unref(showMoviePlayerFullMode)]
    ]),
    _withDirectives(_createVNode(MoviePlayerCompareMode, {
      ref_key: "refMoviePlayerCompareMode",
      ref: refMoviePlayerCompareMode,
      "movie-lists": _unref(moviePlayerState).moviePlayerMovieLists,
      "movie-list-id": _unref(moviePlayerState).moviePlayerCompMovieListId,
      "extreme-map-essentials": _unref(state).extremeMapEssentials,
      "parent-geo-items-meta": _unref(geoItemsMeta),
      "parent-movie-layer-meta": _unref(movieLayerMeta),
      "parent-movie-search": _unref(movieSearchState),
      onClose: _unref(closeMoviePlayer),
      onSwitchToFullMode: _unref(switchMoviePlayerToFullMode)
    }, null, 8, ["movie-lists", "movie-list-id", "extreme-map-essentials", "parent-geo-items-meta", "parent-movie-layer-meta", "parent-movie-search", "onClose", "onSwitchToFullMode"]), [
      [_vShow, _unref(showMoviePlayerCompareMode)]
    ]),
    (_unref(state).ui.waitSpinner.show)
      ? (_openBlock(), _createBlock(_component_LoadWaitSpinner, {
          key: 0,
          message: _unref(state).ui.waitSpinner.msg
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(state).ui.simpleModal.show)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          title: _unref(state).ui.simpleModal.title,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).ui.simpleModal.onClose())),
          onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).ui.simpleModal.onDismiss()))
        }, {
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(state).ui.simpleModal.message), 1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_unref(imageViewModal).show)
      ? (_openBlock(), _createBlock(_component_ModalImageView, {
          key: 2,
          title: _unref(imageViewModal).title,
          "image-urls": _unref(imageViewModal).imageUrls,
          "download-filename-template": _unref(imageViewModal).downloadFilenameTemplate,
          "initial-index": _unref(imageViewModal).initialIndex,
          onClose: _unref(closeImageModal)
        }, null, 8, ["title", "image-urls", "download-filename-template", "initial-index", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(DeleteConfirmModal),
    _createVNode(MovieTagSearchModal),
    _createVNode(MovieTagEditModal)
  ]))
}
}

})